import { NETWORK_CHAIN_ID } from '../connectors'

type EthereumProvider = {
  request?: (args: { method: string; params?: unknown[] }) => Promise<unknown>
}

function getEthereum(): EthereumProvider | undefined {
  return (window as any)?.ethereum
}

function getChainIdHex(chainId: number): string {
  return `0x${chainId.toString(16)}`
}

function getAddChainParams() {
  const rpcUrl = process.env.REACT_APP_NETWORK_URL
  if (!rpcUrl) return null

  const chainName = process.env.REACT_APP_CHAIN_NAME || `Chain ${NETWORK_CHAIN_ID}`
  const currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL || 'ETH'
  const currencyName = process.env.REACT_APP_CURRENCY_NAME || currencySymbol
  const currencyDecimals = parseInt(process.env.REACT_APP_CURRENCY_DECIMALS ?? '18', 10)
  const blockExplorerUrl = process.env.REACT_APP_BLOCK_EXPLORER_URL

  return {
    chainId: getChainIdHex(NETWORK_CHAIN_ID),
    chainName,
    nativeCurrency: {
      name: currencyName,
      symbol: currencySymbol,
      decimals: Number.isFinite(currencyDecimals) ? currencyDecimals : 18
    },
    rpcUrls: [rpcUrl],
    blockExplorerUrls: blockExplorerUrl ? [blockExplorerUrl] : undefined
  }
}

export async function switchToSupportedNetwork(): Promise<boolean> {
  const ethereum = getEthereum()
  if (!ethereum?.request) return false

  const chainIdHex = getChainIdHex(NETWORK_CHAIN_ID)
  try {
    await ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: chainIdHex }]
    })
    return true
  } catch (error) {
    const errorCode = error?.code ?? error?.data?.originalError?.code
    if (errorCode !== 4902) {
      return false
    }
    const params = getAddChainParams()
    if (!params) return false
    try {
      await ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [params]
      })
      return true
    } catch (addError) {
      return false
    }
  }
}
